module.exports = __webpack_public_path__ + "img/img-brand-denagard.6ae7312f.svg";